import { z } from "zod";

const vehicleSchema = z.object({
  vehicle_id: z.coerce.number({
    invalid_type_error: "المركبة مطلوبة",
  }),

  base_price: z.coerce.number().min(1, "سعر البداية مطلوب لجميع المركبات"),
  max_price: z.coerce.number().min(1, "أقصى سعر مطلوب لجميع المركبات"),
  per_km_price: z.coerce.number().min(1, "سعر الكيلو مطلوب"),
  max_cod_price: z.coerce.number().min(1, "أقصى سعر كاش مطلوب"),

  base_price_for_package: z.coerce.number().min(1, "السعر الرئيسي مطلوب"),
  per_km_price_for_package: z.coerce
    .number()
    .min(1, "سعر الكيلو لخدمة اطلب ووصل مطلوب"),

  enable_cod: z.boolean(),
});

export const shippingPricingSchema = z.object({
 zone_id: z.coerce.number({
  invalid_type_error: "المنطقة مطلوبة",
}).refine((val) => !isNaN(val) && val > 0, {
  message: "المنطقة مطلوبة",
}),

  vehicles: z
    .array(vehicleSchema)
    .min(1, "يجب إضافة مركبة واحدة على الأقل"),
});